import { render, staticRenderFns } from "./DictManagement.vue?vue&type=template&id=479d38a6&scoped=true"
import script from "./DictManagement.vue?vue&type=script&lang=js"
export * from "./DictManagement.vue?vue&type=script&lang=js"
import style0 from "./DictManagement.vue?vue&type=style&index=0&id=479d38a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479d38a6",
  null
  
)

export default component.exports